<template>
  <vs-sidebar
    click-not-close
    hidden-background
    class="radar-grid-object-list-container"
    :value="isActiveSidebar"
  >
    <div
      class="radar-grid-object-list-content flex flex-col items-start gap-3 aisea-pt-7 aisea-pr-1 aisea-pl-6 max-h-full"
    >
      <div
        class="radar-grid-object-list-header flex flex-row justify-start items-center gap-3 w-full"
      >
        <span class="target-list-icon"></span>
        <div
          class="radar-grid-object-list-header-title aisea-text-14-400-white"
        >
          {{ headerTitle }}
        </div>
        <span class="close-btn ml-auto" @click="handleClickClose"></span>
      </div>
      <div class="radar-grid-object-list-tab-area flex justify-center gap-2">
        <rg-object-list-tab
          v-for="riskLevel of [
            RG_RISK_LEVEL.DANGER,
            RG_RISK_LEVEL.CAUTION,
            RG_RISK_LEVEL.SAFE,
          ]"
          :key="riskLevel"
          class="aisea-text-14-600-white"
          :riskLevel="riskLevel"
          :selectedRiskLevel="selectedRiskLevel"
          :radarGridObjectFirestoreData="radarGridObjectFirestoreData"
          :rgRiskLevelManagerMap="rgRiskLevelManagerMap"
          :handleClick="handleClickRgObjectListTab(riskLevel)"
        ></rg-object-list-tab>
      </div>
      <component :is="scrollbarTag" class="flex-grow-0" :key="$vs.rtl">
        <div class="radar-grid-object-list flex flex-col gap-2">
          <rg-object-list-item
            v-for="{ id, n, k, p, rgRiskLevelManager } in toBeShowObjects"
            :key="id"
            :trackNumber="n"
            :kind="k"
            :rgRiskLevelManager="rgRiskLevelManager"
            :pictures="p"
            :handleClick="() => handleClickListItem(id)"
            :timeCount="timeCount"
          ></rg-object-list-item>
        </div>
      </component>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import orderBy from "lodash/orderBy";
import { RadarGridMixin } from "@/mixins";
import RgObjectListItem from "./RgObjectListItem.vue";
import RgObjectListTab from "./RgObjectListTab.vue";
import isNumber from "lodash/isNumber";

export default {
  name: "RgObjectListContainer",
  mixins: [RadarGridMixin],
  components: { RgObjectListItem, RgObjectListTab, VuePerfectScrollbar },
  props: {
    isActiveSidebar: { type: Boolean, default: false },
    radarGridObjectFirestoreData: {
      type: Object, // Object<RadarObjectFirestoreData.id, RadarObjectFirestoreData>
      required: true,
    },
    rgRiskLevelManagerMap: {
      type: Object, // Object<RadarGridObject.id, RgRiskLevelManager>
      required: true,
    },
    initialSelectedRiskLevel: {
      type: Number,
      required: false,
    },
    headerTitle: {
      type: String,
      default: "ターゲット一覧",
    },
    handleClickClose: {
      type: Function,
      required: true,
    },
    handleClickListItem: {
      type: Function,
      required: true,
    },
    timeCount: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      selectedRiskLevel: null, // use RG_RISK_LEVEL: 0 | 5 | 10
      // TODO: 次回更新時に使用予定
      // selectedRiskLevels: {}, // Object<RG_RISK_LEVEL: 0 | 5 | 10, Boolean>
    };
  },

  watch: {},
  computed: {
    scrollbarTag() {
      return this.$store.state.is_touch_device ? "div" : "VuePerfectScrollbar";
    },
    // TODO: 次回アラート更新時に修正予定
    dangerObjects() {
      if (!this.radarGridObjectFirestoreData) return [];
      return orderBy(
        Object.values(this.radarGridObjectFirestoreData)
          .filter((radarObject) => radarObject)
          .filter(({ id }) => this.rgRiskLevelManagerMap[id])
          .map((radarObject) => ({
            ...radarObject,
            rgRiskLevelManager: this.rgRiskLevelManagerMap[radarObject.id],
          }))
          .filter(({ rgRiskLevelManager }) =>
            this.isDanger(rgRiskLevelManager.riskLevel),
          ),
        [
          (radarObject) => {
            return (
              Array.isArray(radarObject.p) &&
              radarObject.p[0] &&
              radarObject.p[0].t &&
              radarObject.p[0].t.toMillis()
            );
          },
        ],
        ["desc"],
      );
    },
    cautionObjects() {
      if (!this.radarGridObjectFirestoreData) return [];
      return orderBy(
        Object.values(this.radarGridObjectFirestoreData)
          .filter((radarObject) => radarObject)
          .filter(({ id }) => this.rgRiskLevelManagerMap[id])
          .map((radarObject) => ({
            ...radarObject,
            rgRiskLevelManager: this.rgRiskLevelManagerMap[radarObject.id],
          }))
          .filter(({ rgRiskLevelManager }) =>
            this.isCaution(rgRiskLevelManager.riskLevel),
          ),
        [
          (radarObject) => {
            return (
              Array.isArray(radarObject.p) &&
              radarObject.p[0] &&
              radarObject.p[0].t &&
              radarObject.p[0].t.toMillis()
            );
          },
        ],
        ["desc"],
      );
    },
    safeObjects() {
      if (!this.radarGridObjectFirestoreData) return [];
      return orderBy(
        Object.values(this.radarGridObjectFirestoreData)
          .filter((radarObject) => radarObject)
          .filter(({ id }) => this.rgRiskLevelManagerMap[id])
          .map((radarObject) => ({
            ...radarObject,
            rgRiskLevelManager: this.rgRiskLevelManagerMap[radarObject.id],
          }))
          .filter(({ rgRiskLevelManager }) =>
            this.isSafe(rgRiskLevelManager.riskLevel),
          ),
        [
          (radarObject) => {
            return (
              Array.isArray(radarObject.p) &&
              radarObject.p[0] &&
              radarObject.p[0].t &&
              radarObject.p[0].t.toMillis()
            );
          },
        ],
        ["desc"],
      );
    },
    toBeShowObjects() {
      const { DANGER, CAUTION } = this.RG_RISK_LEVEL;
      const { selectedRiskLevel } = this;
      if (selectedRiskLevel === DANGER) return this.dangerObjects;
      if (selectedRiskLevel === CAUTION) return this.cautionObjects;
      return this.safeObjects;
    },
  },
  methods: {
    setup() {
      this.selectedRiskLevel = isNumber(this.initialSelectedRiskLevel)
        ? this.initialSelectedRiskLevel
        : this.RG_RISK_LEVEL.DANGER;
    },
    handleClickRgObjectListTab(riskLevel) {
      if (!Object.values(this.RG_RISK_LEVEL).includes(riskLevel)) {
        throw new Error("riskLevel is not valid");
      }
      return () => (this.selectedRiskLevel = riskLevel);
    },
  },
  mounted() {
    this.setup();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

.radar-grid-object-list-container {
  .vs-sidebar {
    &.vs-sidebar-parent {
      max-width: 286px;
      background-color: #222222;
      .radar-grid-object-list-header {
        width: 266px;
        .target-list-icon {
          // reset button style
          all: unset;
          outline: revert;
          display: block;

          height: 12px;
          width: 22px;
          border: none;
          outline: none;
          background-image: url("~@/assets/images/radarGrid/last_tracking_object_button.svg");
          background-repeat: no-repeat;
          background-position: left;
          background-size: contain;
        }

        .close-btn {
          display: block;
          position: relative;
          text-align: right;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          background: #222222;
          cursor: pointer;
          user-select: none;

          &:hover {
            background-color: #333333;
            transition: background-color 0.3s ease;
            cursor: pointer;
          }
        }

        .close-btn::before,
        .close-btn::after {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          width: 2px;
          height: 12px;
          background: #fff;
        }

        .close-btn::before {
          transform: translate(-50%, -50%) rotate(45deg);
        }

        .close-btn::after {
          transform: translate(-50%, -50%) rotate(-45deg);
        }
      }
    }
  }
}
</style>
